import { logger } from '@getvim/vim-connect-logger';

export const createLogger = (componentName: string) =>
  logger.scope(`Prior Auth V2 ${componentName}`);
